import { render, staticRenderFns } from "./e-button-contact-create.vue?vue&type=template&id=897cfe6a&scoped=true&lang=pug"
import script from "./e-button-contact-create.vue?vue&type=script&lang=js"
export * from "./e-button-contact-create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897cfe6a",
  null
  
)

export default component.exports